import React from 'react';
import { object, string, func } from 'prop-types';
import Loading from '../../atoms/Loading/index';
import SingleContentLayout from '../../templates/SingleContentLayout';
import SeachContentLayout from '../../templates/SeachContentLayout';
import SearchQuizContent from '../../organisms/SearchQuizContent';
import Redirect from '../../atoms/Redirect';
import AlgoliaSearchContainer from '../../../containers/AlgoliaSearchContainer';
import { REQUESTING } from '../../../constants';

const RedirectWithParameter = ({redirect})=>{
	return <SingleContentLayout render={() => <Redirect redirectTo={redirect} />} />;
};
RedirectWithParameter.propTypes = {
	redirect : func.isRequired
};

export {RedirectWithParameter};

const SearchQuizPage = ({ fetchingState, requestSearchRefresh, error, errorMessage, ...props }) => {
	if (fetchingState === REQUESTING.FETCHING) {
		return <SingleContentLayout render={() => <Loading />} />;
	}
	return (
		<AlgoliaSearchContainer>
			<SeachContentLayout
				renderCards={() => <SearchQuizContent {...props} />}
			/>
		</AlgoliaSearchContainer>); // tbd
};

SearchQuizPage.propTypes = {
	fetchingState: string.isRequired,
	error: object,
	requestSearchRefresh: func.isRequired
};

export default SearchQuizPage;